import React, { Component } from 'react';
import { BrowserRouter } from 'react-router-dom';

import GlobalStyles from './GlobalStyles';

import PagesContainer from '../components/PagesContainer';

import Analytics from '../services/Analytics';
// import Plug from '../pages/Plug';

class Application extends Component {
    constructor(props) {
        super(props);

        Analytics.init('UA-177207442-1');
    }

    render() {
        return (
            <>
                <GlobalStyles />
                <BrowserRouter>
                    <PagesContainer />
                </BrowserRouter>
            </>
        );
    }
}

export default Application;
